import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { InputValidationsService } from '../../shared/services/validations/input-validations.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { InventoryService } from 'src/app/business-service/inventory/inventory.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { DmcPackageService } from 'src/app/business-service/dmc-package/dmc-package.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { LovDataService } from '../../shared/services/lov-data/lov-data.service';
import { create } from 'd3-selection';

@Component({
  selector: 'app-add-vehicle',
  templateUrl: './add-vehicle.component.html',
  styleUrls: ['./add-vehicle.component.scss'],
})
export class AddVehicleComponent  implements OnInit {
  transferDetailsForm!: FormGroup;
  listOfPatchedLocations:any;
  vehicleTypeValues = [
  { key: 'sedan', name: 'Sedan' },
  { key: 'suv', name: 'SUV' },
  { key: 'hatchback', name: 'Hatchback' },
  { key: 'van', name: 'Van' },
  { key: 'minivan', name: 'Minivan' },
  { key: 'luxury_car', name: 'Luxury Car' },
];

 transferModeValues = [
  { key: 'private', name: 'Private' },
  { key: 'public', name: 'Public' },
  { key: 'self_drive', name: 'Self-Drive' },
  { key: 'bike_rental', name: 'Bike Rental' },
  { key: 'carpool', name: 'Carpool' },
];
  
  vehicleNameValues = 
  [
    {
        "key": "Dzire",
        "name": "Dzire"
    },
    {
        "key": "WagonR",
        "name": "WagonR"
    },
    {
        "key": "Ertiga",
        "name": "Ertiga"
    },
    {
        "key": "Innova",
        "name": "Innova"
    },
    {
        "key": "Tavera",
        "name": "Tavera"
    },
    {
        "key": "Sumo",
        "name": "Sumo"
    }
]

  attachedFileName: string | null = null;
  attachedFile: File | null = null;
  @Input() transferId:any;

  storedVehicleData: any;
   
  constructor(    private _modalController: ModalController,
    private _fb: FormBuilder,
    private _validationService: InputValidationsService,
    private _modalPopupService: ModalsService,
    private _globalService: GlobalService,
    private _inventoryService: InventoryService,
    private _responseNotificationService: ResponseNotificationService,
    private _dmcPackageService: DmcPackageService,
    private _reloadService: ComponentReloadService,
    private _lovDataSerivce: LovDataService
  ) { 
    this.transferDetailsForm = this._fb.group({
      transferId:[null],
      id:[null],
      organizationId:[null],
      currency: ['USD'],
      vendorName: ['', Validators.required],
      phoneNumber: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: [''],
      contactEmail: ['', [Validators.required, this._validationService.emailValidator()]],
      vehicleDetails: this._fb.array([]), // Initialize as an empty array
      locations: [[]],
      notes: [''],
      status:[''],
      createdBy: [''],
      createDate: ['']
    });
   
  }

  ngOnInit() {
   
    // Add the first vehicle form group after initializing the form array
    this.addVehicle(); 
  if(this.transferId)
    this.getTransferDetails(this.transferId);
  }


  get vehicleDetails(): FormArray {
    return this.transferDetailsForm.get('vehicleDetails') as FormArray;
  }

  addVehicle() {
    const vehicleGroup = this._fb.group({
      index:[0],
      numberOfSeats: [0,Validators.min(1)],
      vehicleType: ['', Validators.required],
      vehicleName: ['', Validators.required],
      TransferMode: ['', Validators.required],
      pricing: [0],
      priceValidity: this._fb.group({
        startDate: [''],
        endDate: ['']
      }),
      imagePath: [null],
      imageDoc: [null],
    });
  
    this.vehicleDetails.push(vehicleGroup);
    return vehicleGroup;
  }

  removeVehicle(index: number) {
    this.vehicleDetails.removeAt(index);
  }

  onFileSelected(event: any, index: number) {
    const file = event.target.files[0];
    // Checking if image is more than 5MB
    if (file.size > 5 * 1024 * 1024) {
      this._globalService.customAlert("File size should be less than 5MB", "Invalid File Size");
      return;
    }
    if(file){
      const formData = new FormData();
      formData.append('image', file);
      this._lovDataSerivce.uploadImage(formData, "transfers").subscribe({
        next: (res) => {
          this.vehicleDetails.at(index).patchValue({
            imagePath: res,
            imageDoc:file,
          });
           this.transferDetailsForm.markAllAsTouched();
        },
        error: (error) => {
          console.error('Error uploading image: ', error);
          this._responseNotificationService.showMessage("Error uploading image", true);
        }
      });
    }
  }

  openAttachedFile(file: any) {
    
    if (file instanceof File) {
      const fileURL = URL.createObjectURL(file);
      this._modalPopupService.openImageModal(fileURL);

    } else {
      this._modalPopupService.openImageModal(file);
    }
  }


  openexistingAttachedFile(fileURL:string) {
    if (fileURL) 
      this._modalPopupService.openImageModal(fileURL);
  }


  truncateFileName(fileName: string, length: number = 6): string {
    if (!fileName) return '';
    return fileName.length > length ? fileName.substring(0, length) + '...' : fileName;
  }  
  
  onSubmit(saveNew=false) {
    
    if (this.transferDetailsForm) {
      this.transferDetailsForm.markAllAsTouched(); // Mark all fields as touched
    }
  
    if (this.transferDetailsForm.valid) {
      const formValue = this.transferDetailsForm.value;
      const payload = {
        transferId: formValue.transferId || null, // If available
        id:formValue.id||null,
        transferDetails: {
          organizationId:formValue?.organizationId || null,
          currency: formValue.currency,
          vendorName: formValue.vendorName,
          phoneNumber: formValue.phoneNumber, // Adjust if needed
          firstName: formValue.firstName,
          lastName: formValue.lastName,
          contactEmail: formValue.contactEmail,
          locations: formValue.locations,
          vehicleDetails: formValue.vehicleDetails,
        },
        notes: formValue.notes,
        status:formValue.status,
        createDate: this.storedVehicleData?.createDate || null,
        createdBy: this.storedVehicleData?.createdBy || null
      };
  
  
      this._inventoryService.addInventoryVehicle(payload).subscribe({
        next: (data: any) => {
          if (this.transferId) this._responseNotificationService.showMessage("Vehicle Updated Successfully");
          else this._responseNotificationService.showMessage("Vehicle Added Successfully");
          this._reloadService.triggerreloadvehicleslist();
          this._reloadService.triggerreloadvehicleoverview();
          if(saveNew){
            this.transferDetailsForm.reset();
            return;
          }
          this.closeModal();
        },
        error: (err: any) => {
          console.error('API Error:', err);
          this._responseNotificationService.showMessage("Error saving Vehicle Details", true);
        }
      });
  
    } else {
      this._globalService.customAlert("Fill all required fields to save", "Invalid Form");
      console.log('Form is invalid');
    }
  }
  getTransferDetails(transferId:any){
    
    this._inventoryService.getInventoryVehicle(transferId).subscribe({
      next:(res:any)=>{
        this.storedVehicleData = res;
        this.listOfPatchedLocations = res.transferDetails.locations?.map((location: string) => ({
          name: location, // Assigning the string to 'name'
          code3: location // Assigning the string to 'code3'
        }));
        this.patchFormDetails(res)
      },
      error:(error)=>{
        console.log(error);
      }
    })
  }

  patchFormDetails(response: any) {
    
    if (!response) return;
    this.transferDetailsForm.patchValue({
      ...response,
      organizationId:response?.organizationId || null,
      vendorName: response.transferDetails?.vendorName || '',
      currency: response.transferDetails?.currency || '',
      phoneNumber: response.transferDetails?.phoneNumber || '',
      firstName: response.transferDetails?.firstName || '',
      lastName: response.transferDetails?.lastName || '',
      contactEmail: response.transferDetails?.contactEmail || '',
      locations: response.transferDetails?.locations || '',
      notes: response.notes || '',
      status: response.status || ''

    });
  
    // Clear and repopulate vehicleDetails array
    const vehicleDetailsArray = this.transferDetailsForm.get('vehicleDetails') as FormArray;
    vehicleDetailsArray.clear();
  
    if (response.transferDetails?.vehicleDetails?.length) {
      response.transferDetails.vehicleDetails.forEach((vehicle: any) => {
        const vehicleGroup = this._fb.group({
          index:vehicle.index,
          numberOfSeats: [vehicle.numberOfSeats || 0],
          vehicleType: [vehicle.vehicleType || '', Validators.required],
          vehicleName: [vehicle.vehicleName || '', Validators.required],
          TransferMode: [vehicle.transferMode || '', Validators.required],
          pricing: [vehicle.pricing || 0, Validators.required],
          priceValidity: this._fb.group({
            startDate: [vehicle.priceValidity?.startDate || '', Validators.required],
            endDate: [vehicle.priceValidity?.endDate || '', Validators.required]
          }),
          imagePath: [vehicle.imagePath || ''],
          imageDoc: [vehicle.imagePath || ''],
        });
  
        vehicleDetailsArray.push(vehicleGroup);
      });
    }
  }
  removeTransfersImage(index:number){
    this.vehicleDetails.at(index).patchValue({
      imagePath: null,
      imageDoc:null
    });
  }
   
  closeModal() {
    this._modalController.dismiss();
  }

  formDataModified(): boolean {
    return this.transferDetailsForm.dirty || this.transferDetailsForm.touched;
  }
  
}
